export default "__VITE_ASSET__CJJmcQhE__"